import { render, staticRenderFns } from "./NewTransferSummary.vue?vue&type=template&id=1be9aeea"
import script from "./NewTransferSummary.vue?vue&type=script&lang=js"
export * from "./NewTransferSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports